/* ai-disclaimer-and-feedback.tsx generated by @compiled/babel-plugin v0.38.1 */
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./ai-disclaimer-and-feedback.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import CopyIcon from '@atlaskit/icon/core/copy';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import Link from '@atlaskit/link';
import { fg } from '@atlaskit/platform-feature-flags';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { onAIAnswerCopyButtonClicked } from '../../../ai-answer-dialog/analytics';
import { useSmartAnswerCardFeedbackOptions } from '../../../ai-answer-dialog/smart-answer-card/use-smart-answer-card-feedback-options';
import { useAnalytics } from '../../../common/controller/analytics';
import { SainAction, useSAINUsageCriteriaMet } from '../../../common/controller/analytics/hooks/use-sain-usage';
import { AIFeedbackV2 } from '../../../common/ui/ai-feedback-v2';
import { ATLASSIAN_INTELLIGENCE_TRUST_LINK, QueryIntent } from '../../../constants';
import { OnlineDebuggerButton } from './online-debugger-button';
var messages = defineMessages({
  ai_content_disclaimer: {
    id: 'search_ai.ai_content_disclaimer',
    defaultMessage: 'Uses AI. Verify results.',
    description: 'Text for the AI content disclaimer'
  }
});
var copyIcon = function copyIcon() {
  return /*#__PURE__*/React.createElement(CopyIcon, {
    color: "var(--ds-icon-subtlest, #6B6E76)",
    LEGACY_size: "small",
    label: "copy"
  });
};
var styles = {
  heightWrapper: "_4t3i1tcg"
};
export function AIDisclaimerAndFeedback(_ref) {
  var showFeedbackButtons = _ref.showFeedbackButtons,
    showCopyButton = _ref.showCopyButton,
    copyText = _ref.copyText,
    renderedContentRef = _ref.renderedContentRef;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    smartAnswersRoute = _useAIAnswerContext.smartAnswersRoute,
    isAnswered = _useAIAnswerContext.isAnswered;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var answerString = commonAttributes.answerString;
  var feedbackOptions = useSmartAnswerCardFeedbackOptions();
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var showOnlineDebuggerButton = isAnswered && smartAnswersRoute === QueryIntent.NATURAL_LANGUAGE_QUERY && fg('kd_sain_online_debugger');
  var onLinkClickHandler = function onLinkClickHandler(event) {
    // prevent clicks from bubbling up to the Pressable ancestor and causing the card to expand
    event.stopPropagation();
  };
  var onLikeButtonClickHandler = function onLikeButtonClickHandler(event) {
    // prevent clicks from bubbling up to the Pressable ancestor and causing the card to expand
    event.stopPropagation();
    feedbackOptions.onLikeButtonClickHandler();
  };
  var onDislikeButtonClickHandler = function onDislikeButtonClickHandler(event) {
    // prevent clicks from bubbling up to the Pressable ancestor and causing the card to expand
    event.stopPropagation();
    feedbackOptions.onDislikeButtonClickHandler();
  };
  var onCopyButtonClickHandler = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var node, htmlBlob, textBlob;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // prevent clicks from bubbling up to the Pressable ancestor and causing the card to expand
            event.stopPropagation();
            fireSAINUsageEvent({
              metCriteria: SainAction.COPY_CLICKED,
              commonAttributes: commonAttributes
            });
            fireAnalyticsEvent(onAIAnswerCopyButtonClicked(commonAttributes));
            if (!copyText) {
              _context.next = 8;
              break;
            }
            _context.next = 6;
            return navigator.clipboard.writeText(copyText);
          case 6:
            _context.next = 25;
            break;
          case 8:
            _context.prev = 8;
            node = renderedContentRef === null || renderedContentRef === void 0 ? void 0 : renderedContentRef.current;
            if (!node) {
              _context.next = 17;
              break;
            }
            htmlBlob = new Blob([node.innerHTML], {
              type: 'text/html'
            });
            textBlob = new Blob([answerString], {
              type: 'text/plain'
            });
            _context.next = 15;
            return navigator.clipboard.write([new ClipboardItem({
              'text/html': htmlBlob,
              'text/plain': textBlob
            })]);
          case 15:
            _context.next = 19;
            break;
          case 17:
            _context.next = 19;
            return navigator.clipboard.writeText(answerString);
          case 19:
            _context.next = 25;
            break;
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](8);
            _context.next = 25;
            return navigator.clipboard.writeText(answerString);
          case 25:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[8, 21]]);
    }));
    return function onCopyButtonClickHandler(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "end",
    grow: "fill",
    spread: "space-between",
    xcss: styles.heightWrapper
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    space: "space.025"
  }, /*#__PURE__*/React.createElement(StatusInformationIcon, {
    color: "var(--ds-icon-subtle, #626F86)",
    label: "",
    size: "small",
    spacing: "compact"
  }), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, /*#__PURE__*/React.createElement(Link, {
    appearance: "subtle",
    href: ATLASSIAN_INTELLIGENCE_TRUST_LINK,
    onClick: onLinkClickHandler,
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_content_disclaimer)))), /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    space: "space.050"
  }, showFeedbackButtons ? /*#__PURE__*/React.createElement(AIFeedbackV2, {
    entrypointId: feedbackOptions.entrypointId,
    userDetails: feedbackOptions.userDetails,
    attributes: feedbackOptions.attributes,
    attributesWithConsent: feedbackOptions.attributesWithConsent,
    onLikeButtonClickHandler: onLikeButtonClickHandler,
    onDislikeButtonClickHandler: onDislikeButtonClickHandler
  }) : null, showCopyButton ? /*#__PURE__*/React.createElement(IconButton, {
    icon: copyIcon,
    label: "Copy",
    onClick: onCopyButtonClickHandler,
    appearance: "subtle",
    isTooltipDisabled: false,
    spacing: "compact"
  }) : null, showOnlineDebuggerButton && /*#__PURE__*/React.createElement(OnlineDebuggerButton, null)));
}